import i18n from '@/i18n'
import { pickBy } from '@/utils'
import AttrGoods from './attr-goods'
import CtaItem from "../hm-stage/ctaItem.vue"
export default {
  name: 'HmShowcase',
  setting: [
    { label: '标题', key: 'title', component: 'input', value: '标题' },
    {
      label: '按钮文案',
      key: 'cta',
      component: function (h, { key }){
        return <CtaItem  v-model={this.value[key]}></CtaItem>
      },
      value: {
        desc: '按钮文案',
        urlData: {}
      }
    },
    // {
    //   label: '样式',
    //   key: 'style',
    //   component: 'radio',
    //   options: [
    //     { name: '一行两个', label: 'grid' },
    //     { name: '一行三个', label: 'grids' },
    //     { name: '一行四个', label: 'gridsTwo' }
    //   ],
    //   value: 'grid'
    // },
    // { label: i18n.t('wgt_goodsGrid.config.739698-8'), key: 'showPrice', component: 'switch', value: false },
    // { label: i18n.t('wgt_goodsGrid.config.739698-9'), key: 'brand', component: 'switch', value: true },
    {
      label: '选择商品',
      key: 'data',
      component: function (h, { key }) {
        return <AttrGoods v-model={this.value[key]} />
      },
      value: [
        {
          imgUrl: '',
          linkPage: '',
          content: '',
          title: '图片1',
          id: '',
          price: 0,
          market_price: 0
        },
        {
          imgUrl: '',
          linkPage: '',
          content: '',
          title: '图片2',
          id: '',
          price: 0,
          market_price: 0
        },
        {
          imgUrl: '',
          linkPage: '',
          content: '',
          title: '图片3',
          id: '',
          price: 0,
          market_price: 0
        },
        {
          imgUrl: '',
          linkPage: '',
          content: '',
          title: '图片4',
          id: '',
          price: 0,
          market_price: 0
        }
      ]
    }
  ],
  transformIn: (v) => {
    const {
      name,
      base,
      config
    } = v
    return {
      name,
      ...base,
      ...config
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
        })
      },
      config: (v) => {
        return pickBy(v, {
          title: 'title',
          cta: 'cta',
          data: 'data'
        })
      },
    })
  }
}
